(function () {
  var doc = document;

  /* Galerie: Vorschaubild anklicken tauscht das große Bild */
  var stageImg = doc.getElementById("stageImg");
  doc.querySelectorAll("#rail .rail__i").forEach(function (b) {
    b.addEventListener("click", function () {
      doc.querySelectorAll("#rail .rail__i").forEach(function (x) { x.classList.remove("is-active"); });
      b.classList.add("is-active");
      if (stageImg) { stageImg.src = b.dataset.src; stageImg.alt = b.dataset.cap || ""; }
    });
  });

  /* Variantenwahl: Preis und verstecktes Feld nachziehen.
     Das Feld heißt "id" — daran hängt Shopify die Bestellung, nicht am Text. */
  var varId = doc.getElementById("varId"), preis = doc.getElementById("kaufPreis");
  doc.querySelectorAll("#varGrid .bcard").forEach(function (c) {
    c.addEventListener("click", function () {
      doc.querySelectorAll("#varGrid .bcard").forEach(function (x) {
        x.classList.remove("is-active"); x.setAttribute("aria-pressed", "false");
      });
      c.classList.add("is-active"); c.setAttribute("aria-pressed", "true");
      if (varId) varId.value = c.dataset.vid;
      preisNachziehen();
      groessenSyncen();
    });
  });

  /* ── Groesse je Paar (nur Knickschutz) ────────────────────────────────
     Die Felder heissen properties[Groesse Paar N] und wuerden bei einem
     normalen Formular-Absenden automatisch mitgehen. Hier nicht: ablegen()
     faengt das submit ab und baut die Anfrage selbst. Die Werte muessen
     deshalb von Hand angehaengt werden — sonst kaeme die Bestellung ohne
     Groesse an, und zwar lautlos. */
  var groessenBox = doc.getElementById("groessen");
  var groessenFehler = doc.getElementById("groessenFehler");

  function groessenFelder() {
    return groessenBox ? [].slice.call(groessenBox.querySelectorAll(".groesse__f")) : [];
  }

  function paareDerWahl() {
    var aktiv = doc.querySelector("#varGrid .bcard.is-active");
    var n = aktiv ? parseInt(aktiv.dataset.paare, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : Math.min(n, 3);
  }

  function groessenSyncen() {
    if (!groessenBox) return;
    var wieviele = paareDerWahl();
    groessenFelder().forEach(function (f) {
      var n = parseInt(f.dataset.paar, 10);
      var zeile = f.closest(".groesse");
      /* Buendelfelder tragen data-fest: sie haengen an keiner Paarzahl,
         sondern am Inhalt des Buendels, und bleiben deshalb immer stehen.
         Ohne diese Zeile waere n NaN, NaN <= wieviele false — und das Feld
         waere ausgeblendet und abgeschaltet, also unsichtbar pflichtig. */
      var noetig = f.dataset.fest === "1" || n <= wieviele;
      if (zeile) zeile.hidden = !noetig;
      f.disabled = !noetig;
      /* required wandert mit: sonst traegt Paar 3 nach dem Aufschalten zwar
         eine Pflicht im Kopf des Skripts, aber keine im Browser. */
      f.required = noetig;
      /* Ausgeblendetes Feld wird geleert. Sonst haengt beim Wechsel
         3 -> 1 -> 3 die alte Groesse von Paar 3 noch drin, obwohl der
         Kunde sie zwischendurch gar nicht sehen konnte. */
      if (!noetig) f.value = "";
      f.setAttribute("data-leer", f.value ? "nein" : "ja");
      f.classList.remove("is-fehlt");
    });
    if (groessenFehler) groessenFehler.hidden = true;
  }

  function groessenPruefen() {
    if (!groessenBox) return true;
    var offen = groessenFelder().filter(function (f) { return !f.disabled && !f.value; });
    groessenFelder().forEach(function (f) { f.classList.remove("is-fehlt"); });
    if (!offen.length) { if (groessenFehler) groessenFehler.hidden = true; return true; }
    offen.forEach(function (f) { f.classList.add("is-fehlt"); });
    if (groessenFehler) {
      /* Bei den Paaren bleibt der Wortlaut Zeichen fuer Zeichen wie bisher.
         Fehlt die Groesse dagegen an einem Buendelteil, muss dort sein Name
         stehen — "Paar undefined" waere die Alternative. */
      var nrn = offen.map(function (f) { return f.dataset.paar; });
      if (nrn.every(function (x) { return x; })) {
        groessenFehler.textContent = nrn.length === 1
          ? "Bitte noch die Größe für Paar " + nrn[0] + " wählen."
          : "Bitte noch die Größen für die Paare " + nrn.slice(0, -1).join(", ") + " und " + nrn[nrn.length - 1] + " wählen.";
      } else {
        var wo = offen.map(function (f) { return f.dataset.wofuer || "diesen Artikel"; });
        groessenFehler.textContent = wo.length === 1
          ? "Bitte noch die Größe für " + wo[0] + " wählen."
          : "Bitte noch die Größen für " + wo.slice(0, -1).join(", ") + " und " + wo[wo.length - 1] + " wählen.";
      }
      groessenFehler.hidden = false;
    }
    offen[0].focus();
    return false;
  }

  function groessenWerte() {
    var w = {};
    groessenFelder().forEach(function (f) {
      if (!f.disabled && f.value) w[f.name.replace(/^properties\[/, "").replace(/\]$/, "")] = f.value;
    });
    return w;
  }

  groessenFelder().forEach(function (f) {
    f.addEventListener("change", function () {
      f.setAttribute("data-leer", f.value ? "nein" : "ja");
      f.classList.remove("is-fehlt");
      var nochOffen = groessenFelder().some(function (x) { return !x.disabled && !x.value; });
      if (groessenFehler && !nochOffen) groessenFehler.hidden = true;
    });
  });
  groessenSyncen();

  /* Lightbox */
  var lb = doc.getElementById("lightbox"), lbImg = doc.getElementById("lightboxImg"),
      zoom = doc.getElementById("stageZoom"), zu = doc.getElementById("lightboxClose");
  function auf() { if (!stageImg) return; lbImg.src = stageImg.src; lb.classList.add("open"); lb.setAttribute("aria-hidden", "false"); }
  function schliessen() { lb.classList.remove("open"); lb.setAttribute("aria-hidden", "true"); }
  if (zoom) zoom.addEventListener("click", auf);
  if (zu) zu.addEventListener("click", schliessen);
  if (lb) lb.addEventListener("click", function (e) { if (e.target === lb) schliessen(); });
  addEventListener("keydown", function (e) { if (e.key === "Escape") schliessen(); });

  /* Fortschrittsbalken am oberen Rand */
  var sbar = doc.querySelector("#scrollbar i");
  var kaufbar = doc.getElementById("kaufbar");
  var kaufbox = doc.querySelector(".pdp__buy");
  addEventListener("scroll", function () {
    var h = doc.documentElement.scrollHeight - innerHeight;
    if (sbar) sbar.style.width = (h > 0 ? (scrollY / h) * 100 : 0) + "%";
    // Balken zeigen, sobald der eigentliche Kaufen-Knopf oben raus ist
    if (kaufbar && kaufbox) {
      var unten = kaufbox.getBoundingClientRect().bottom;
      kaufbar.classList.toggle("show", unten < 60);
      /* 06.09.2026: Derselbe Zustand zusaetzlich am <body>, damit der
         Hilfe-Knopf (snippets/mv-hilfe.liquid) ausweichen kann. Gemessen
         auf 375x812: der Knopf liegt bei z-index 9000 ueber dem Balken
         (z-index 60) und deckte dessen "In den Warenkorb"-Knopf komplett
         ab - 54 px Ueberlappung. Bewusst DERSELBE Ausdruck wie eine Zeile
         darueber: zwei getrennte Schwellen laufen mit der Zeit auseinander,
         und dann steht der Knopf oben, waehrend kein Balken da ist. */
      doc.body.classList.toggle("kaufbar-an", unten < 60);
    }
  }, { passive: true });

  /* ---------- WARENKORB OHNE NEULADEN ----------
     Statt eines Formular-POST auf /cart legen wir über /cart/add.js ab. Die Seite
     bleibt stehen, die Scrollposition auch — nur so ist Weiterkaufen zumutbar. */
  var form = doc.getElementById("kaufform");
  var korb = doc.getElementById("korb"), korbBody = doc.getElementById("korbBody"),
      korbSumme = doc.getElementById("korbSumme");

  function euro(cent) {
    return (cent / 100).toFixed(2).replace(".", ",") + " €";
  }
  /* ---- Kopfhoehe MESSEN, nicht schaetzen --------------------------------
     Warum ueberhaupt: Das Korb-Panel liegt auf z-index 120, der
     Ankuendigungsbalken auf 900 und die Kopfzeile auf 800. Beide werden also
     ueber dem Panel gezeichnet und verdecken seinen oberen Rand. Bis hierher
     war das ein echter Fehler - der Schliessen-Knopf des Panels war gar nicht
     erreichbar, die erste Zeile oben angeschnitten.

     Warum gemessen und nicht eingetippt: Der Balken ist ein Lauftext. Seine
     Hoehe aendert sich mit der Schriftgroesse, mit dem Zeilenumbruch, beim
     Drehen des Geraets, und er kann ganz abgeschaltet werden. Eine feste Zahl
     ist beim naechsten Geraet wieder falsch. (Anderswo im Theme stehen 66px
     und 96px fest verdrahtet - die bleiben hier unangetastet, das waere ein
     eigener Vorgang.) */
  var balken = doc.querySelector(".ticker"), kopfzeile = doc.querySelector(".nav");

  function klebtOben(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === "none" || s.visibility === "hidden") return false;
    /* Nur was wirklich stehen bleibt, deckt das Panel ab. Scrollt die Kopfzeile
       mit, verdeckt sie nichts. */
    if (s.position !== "fixed" && s.position !== "sticky") return false;
    return el.getBoundingClientRect().height > 0;
  }

  function kopfhoeheMessen() {
    /* Gemessen wird in assets/mv-rahmen.js - das ist die eine Quelle, weil
       auch die Warenkorbseite den Wert braucht. Nur falls die Datei fehlt,
       wird hier selbst gemessen. */
    if (typeof window.mvKopfhoehe === "function") { window.mvKopfhoehe(); return; }
    var unten = 0;
    [balken, kopfzeile].forEach(function (el) {
      if (!klebtOben(el)) return;
      unten = Math.max(unten, el.getBoundingClientRect().bottom);
    });
    doc.documentElement.style.setProperty("--kopf-hoehe", Math.max(0, Math.round(unten)) + "px");
  }

  kopfhoeheMessen();
  addEventListener("resize", kopfhoeheMessen);
  addEventListener("orientationchange", kopfhoeheMessen);
  /* Ein ResizeObserver faengt auch das, was kein resize-Ereignis ausloest:
     der Balken wird abgeschaltet, die Kopfzeile wechselt beim Scrollen in
     ihren kompakteren Zustand (.nav.is-solid hat weniger Innenabstand). */
  if (window.ResizeObserver) {
    var beobachter = new ResizeObserver(kopfhoeheMessen);
    [balken, kopfzeile].forEach(function (el) { if (el) beobachter.observe(el); });
  }

  function korbAuf() {
    kopfhoeheMessen();
    korb.classList.add("open");
    korb.setAttribute("aria-hidden", "false");
    doc.body.style.overflow = "hidden";
    /* Immer oben anfangen. Kommt bei bereits offenem Korb ein Artikel dazu,
       wird die Liste neu aufgebaut und stuende sonst mitten drin. */
    if (korbBody) korbBody.scrollTop = 0;
  }
  function korbZu() { korb.classList.remove("open"); korb.setAttribute("aria-hidden", "true"); doc.body.style.overflow = ""; }

  function zaehlerSetzen(n) {
    var z = doc.querySelector(".nav__cart-count");
    if (z) { z.textContent = n; z.classList.add("show"); }
    else if (n > 0) {
      var c = doc.querySelector(".nav__cart");
      if (c) { var s = doc.createElement("span"); s.className = "nav__cart-count show"; s.textContent = n; c.appendChild(s); }
    }
  }

  /* ---- Groesse an den Zusatzartikeln ------------------------------------
     Knickschutz und Silikonueberzug brauchen eine Groesse - auch dann, wenn sie
     nicht das Hauptprodukt sind, sondern nur als Haekchen "Das passt dazu"
     mitlaufen. Ohne sie stuende in der Bestellung ein Paar, von dem niemand
     weiss, welche Groesse zu packen ist. Das Feld erscheint erst mit dem
     Haekchen - vorher waere es nur Ballast. */
  function zusatzHaken() {
    return [].slice.call(doc.querySelectorAll(".xitem__cb"));
  }
  function zusatzBox(c) {
    var id = c.getAttribute("data-gr");
    return id ? doc.getElementById(id) : null;
  }
  function zusatzFeld(c) {
    var b = zusatzBox(c);
    return b ? b.querySelector("[data-mvg]") : null;
  }
  function zusatzMeldung(c, zeigen) {
    var b = zusatzBox(c);
    var m = b ? b.querySelector(".mvg__fehl") : null;
    if (m) m.hidden = !zeigen;
  }
  function zusatzSyncen(c) {
    var b = zusatzBox(c);
    if (!b) return;
    b.hidden = !c.checked;
    if (!c.checked) {
      /* Beim Abwaehlen leeren: sonst haengt beim Haken -> weg -> Haken die alte
         Groesse noch drin, obwohl der Kunde sie zwischendurch nicht sah. */
      var f = zusatzFeld(c);
      if (f) { f.value = ""; f.classList.remove("is-fehlt"); }
      zusatzMeldung(c, false);
    }
  }
  function zusatzPruefen() {
    var offen = null;
    zusatzHaken().forEach(function (c) {
      var f = c.checked ? zusatzFeld(c) : null;
      if (!f) return;
      if (f.value) { f.classList.remove("is-fehlt"); zusatzMeldung(c, false); return; }
      f.classList.add("is-fehlt");
      zusatzMeldung(c, true);
      if (!offen) offen = f;
    });
    if (!offen) return true;
    offen.focus();
    return false;
  }
  zusatzHaken().forEach(function (c) {
    c.addEventListener("change", function () { zusatzSyncen(c); });
    var f = zusatzFeld(c);
    if (f) {
      f.addEventListener("change", function () {
        f.classList.toggle("is-fehlt", !f.value);
        zusatzMeldung(c, false);
      });
    }
    /* Beim Laden gleichziehen: manche Browser stellen beim Zurueckblaettern den
       alten Haken wieder her, das Feld waere dann faelschlich zugeklappt. */
    zusatzSyncen(c);
  });

  function extras() {
    // Angehakte Zusatzartikel gehen im selben Aufruf mit, nicht als zweiter Vorgang
    return zusatzHaken()
      .filter(function (c) { return c.checked && c.dataset.variant; })
      .map(function (c) {
        var posten = { id: Number(c.dataset.variant), quantity: 1 };
        var f = zusatzFeld(c);
        if (f && f.value) {
          /* Der Name kommt aus dem Feld selbst - "Groesse Paar 1" mit echtem
             Umlaut, Wort fuer Wort wie auf der Produktseite. Zwei Schreibweisen
             fuer dieselbe Angabe machen die Packliste unbrauchbar. */
          posten.properties = {};
          posten.properties[f.getAttribute("data-mvg-name")] = f.value;
        }
        return posten;
      });
  }

  var mengeFeld = doc.getElementById("mengeFeld");

  function menge() {
    // Nur Ein-Varianten-Produkte haben einen Mengenwaehler; sonst steckt die Menge
    // in der Variante selbst und darf hier nicht zusaetzlich multipliziert werden.
    var n = mengeFeld ? parseInt(mengeFeld.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : Math.min(n, 10);
  }

  /* Die Warenkorb-Schublade zeigte bisher nur Titel und Variante. Die
     Groessen stehen aber in den Line Item Properties — ohne diese Zeile
     saehe der Kunde beim Nachsehen nicht, was er gewaehlt hat.
     Felder mit fuehrendem Unterstrich bleiben aussen vor, so wie Shopify
     es auch in der Kasse handhabt. */
  function sicher(s) {
    return String(s).replace(/[&<>"']/g, function (z) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[z];
    });
  }

  /* ---- Buendel im Mini-Warenkorb -------------------------------------
     Die Bestandteile und der Gegenwert kommen aus mv-gegenwert (Modus 'daten').
     Hier wird NICHT neu gerechnet, was dort schon gerechnet ist - nur die
     Ersparnis je Position mit der Menge multipliziert.

     Genau diese Multiplikation ist die Stelle, die erfahrungsgemaess vergessen
     wird: liegen 2 x dasselbe Buendel im Korb, sind es 2 x 16,90 EUR. */
  var BUENDEL = (function () {
    var el = doc.getElementById("mvBuendelDaten");
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  })();

  function buendelZu(posten) {
    return BUENDEL[String(posten.product_id)] || null;
  }

  function ersparnisVon(posten) {
    var b = buendelZu(posten);
    if (!b || !b.gegenwert) return 0;
    /* Liegt der Buendelpreis nicht unter dem Gegenwert, wird nichts angezeigt -
       dann stimmt etwas an den Preisen nicht, und "0,00 EUR gespart" waere
       schlimmer als gar keine Zeile. */
    /* posten.price und NICHT posten.final_price: final_price ist der Preis
       NACH Abzug automatischer Rabatte. Der Gegenwert oben ist dagegen aus
       ungerabatteten Einzelpreisen gerechnet. Wer beides vergleicht, zaehlt
       den Rabatt der Bundler-App ein zweites Mal.

       Am 30.08.2026 nachgestellt: zwei Mal "Waschgang komplett" im Korb
       meldet price 5395, final_price 4478. Mit final_price stuenden im Korb
       52,14 EUR Ersparnis, auf der Produktseite aber 16,90 EUR - zwei Zahlen
       fuer dieselbe Sache, und die hoehere ist falsch. Der Mengenrabatt gilt
       auch beim Einzelkauf und ist deshalb keine Buendel-Ersparnis. */
    var je = b.gegenwert - posten.price;
    return je > 0 ? je * posten.quantity : 0;
  }

  function bestandteile(posten) {
    var b = buendelZu(posten);
    if (!b || !b.teile || !b.teile.length) return "";
    /* Die Stueckzahl je Bestandteil mal der Menge der Warenkorbzeile. Ohne das
       stuende bei "3 x Waschgang komplett" darunter "2 x Tasche", obwohl es
       sechs sind. Greift erst, wenn ein Buendel ein Teil doppelt enthaelt -
       heute enthaelt keines das, aber die Zahl waere dann still falsch. */
    var menge = posten.quantity || 1;
    return '<div class="korb__teile">' + b.teile.map(function (x) {
      var n = (x.m || 1) * menge;
      return '<div class="korb__teil">' +
        (x.b ? '<img src="' + sicher(x.b) + '" alt="" width="24" height="24" loading="lazy">' : '<i></i>') +
        '<span>' + (n > 1 ? n + " \u00d7 " : "") + sicher(x.t) + "</span></div>";
    }).join("") + "</div>";
  }

  function eigenschaften(i) {
    if (!i.properties) return "";
    var teile = [];
    Object.keys(i.properties).forEach(function (k) {
      if (k.charAt(0) === "_" || !i.properties[k]) return;
      teile.push(sicher(k) + ": " + sicher(i.properties[k]));
    });
    return teile.length ? '<span class="korb__eig">' + teile.join("<br>") + "</span>" : "";
  }

  function hauptposten(id, nurDiese) {
    var posten = { id: Number(id), quantity: nurDiese ? 1 : menge() };
    if (!nurDiese) {
      var g = groessenWerte();
      if (Object.keys(g).length) posten.properties = g;
    }
    return posten;
  }

  function ablegen(nurDiese) {
    /* Ohne Groesse kein Warenkorb. Ein Buendel-Direktkauf (nurDiese) ist
       davon nicht betroffen, der traegt seine Groesse in der Variante. */
    if (!nurDiese && !groessenPruefen()) return;
    /* Und dasselbe fuer die angehakten Zusatzartikel. Erst danach geht etwas in
       den Korb - sonst schluepft der Knickschutz als Beiwerk ohne Groesse
       durch, waehrend das Hauptprodukt sauber geprueft wurde. */
    if (!nurDiese && !zusatzPruefen()) return;
    var id = nurDiese || (doc.getElementById("varId") || form.querySelector('[name="id"]')).value;
    var knopf = form.querySelector('button[type="submit"]');
    if (knopf) { knopf.disabled = true; knopf.classList.add("is-busy"); }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      // Ein Buendel geht immer einzeln in den Korb — es traegt seine Menge im Produkt.
      body: JSON.stringify({ items: [hauptposten(id, nurDiese)].concat(nurDiese ? [] : extras()) })
    })
      .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
      .then(function () { return fetch("/cart.js", { headers: { "Accept": "application/json" } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gesamtGespart = 0;
        korbBody.innerHTML = cart.items.map(function (i) {
          var gespart = ersparnisVon(i);
          gesamtGespart += gespart;
          /* Ohne Bild KEIN leeres src: der Browser loest src="" als die
             aktuelle Seiten-URL auf und laedt die ganze Produktseite als Bild
             nach. Stattdessen dieselbe leere Flaeche wie bei den Bestandteilen. */
          var bild = i.image
            ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") + '" alt="">'
            : '<i class="korb__kein-bild"></i>';
          return '<div class="korb__zeile">' + bild +
            '<div><b>' + sicher(i.product_title) + '</b><span>' + sicher(i.variant_title || "") + '</span>' +
              eigenschaften(i) + '</div>' +
            '<span class="korb__preis">' + i.quantity + " × " + euro(i.final_price) +
              (gespart > 0 ? '<em class="korb__spar">Du sparst ' + euro(gespart) + "</em>" : "") +
            "</span></div>" +
            bestandteile(i);
        }).join("");
        korbSumme.textContent = euro(cart.total_price);

        /* Gesamtersparnis ueber dem Kaufknopf. Keine Ersparnis, keine Zeile -
           eine leere Zeile oder "0,00 EUR" waere nur Rauschen. */
        var sparGes = doc.getElementById("korbSparGes");
        if (sparGes) {
          sparGes.hidden = gesamtGespart <= 0;
          var betrag = sparGes.querySelector("strong");
          if (betrag) betrag.textContent = euro(gesamtGespart);
        }
        // Der Versandfortschritt auf DIESER Seite wird von Dawn nicht neu
        // gerendert - Warenkorb und Mini-Warenkorb schon. Deshalb hier von
        // Hand nachziehen, sonst steht die Zeile nach dem Ablegen still.
        if (window.mvVersandAktualisieren) {
          window.mvVersandAktualisieren(cart.items_subtotal_price);
        }
        zaehlerSetzen(cart.item_count);
        doc.querySelectorAll(".xitem__cb").forEach(function (c) { c.checked = false; });
        preisNachziehen();
        korbAuf();
      })
      .catch(function () {
        // Geht etwas schief, nicht stillschweigend scheitern: normal absenden.
        form.submit();
      })
      .then(function () {
        if (knopf) { knopf.disabled = false; knopf.classList.remove("is-busy"); }
      });
  }

  /* Der Preis am Kaufknopf zeigt, was tatsaechlich abgelegt wird: Hauptartikel plus Haken. */
  function preisNachziehen() {
    var basis;
    var aktiv = doc.querySelector("#varGrid .bcard.is-active");
    if (aktiv) {
      var quelle = aktiv.querySelector(".bcard__prices b");
      if (!quelle) return;
      basis = parseFloat(quelle.textContent.replace(/[^0-9,]/g, "").replace(",", "."));
    } else {
      // Ein-Varianten-Produkt: Einzelpreis steht am Mengenwaehler, mal gewaehlter Menge.
      var mw = doc.querySelector(".mengew");
      if (!mw) return;
      basis = parseFloat(mw.dataset.einzel) * menge();
    }
    if (isNaN(basis)) return;
    var zusatz = [].slice.call(doc.querySelectorAll(".xitem__cb"))
      .filter(function (c) { return c.checked; })
      .reduce(function (a, c) { return a + parseFloat(c.dataset.price || 0); }, 0);
    var txt = (basis + zusatz).toFixed(2).replace(".", ",") + " €";
    var el = doc.getElementById("kaufPreis"), kb = doc.getElementById("kaufbarPreis");
    if (el) el.textContent = txt;
    if (kb) kb.textContent = txt;
  }
  doc.querySelectorAll(".xitem__cb").forEach(function (c) {
    c.addEventListener("change", preisNachziehen);
  });

  /* Buendel: legt das Buendelprodukt ab, nicht die Einzelteile. Der Preis haengt am
     Produkt — so kann die Seite keinen Preis versprechen, den die Kasse nicht nimmt. */
  doc.querySelectorAll("[data-buendel]").forEach(function (b) {
    b.addEventListener("click", function () {
      /* Buendel mit Groessenoption: erster Klick klappt die Auswahl auf, der
         Knopf bleibt danach gesperrt, bis eine Groesse gewaehlt ist. Die
         Groesse steckt hier in der VARIANTE, deshalb wird die Varianten-ID
         gewechselt und keine Property gesetzt. */
      var grId = b.getAttribute("data-buendel-groesse");
      if (grId) {
        var box = doc.getElementById(grId);
        var feld = box ? box.querySelector("select") : null;
        if (box && box.hidden) {
          box.hidden = false;
          b.setAttribute("aria-expanded", "true");
          b.disabled = true;
          if (feld) {
            feld.focus();
            feld.addEventListener("change", function () {
              b.disabled = !feld.value;
              feld.classList.toggle("is-fehlt", !feld.value);
            });
          }
          return;
        }
        if (!feld || !feld.value) {
          if (feld) { feld.classList.add("is-fehlt"); feld.focus(); }
          return;
        }
        ablegen(feld.value);
        return;
      }
      ablegen(b.dataset.buendel);
    });
  });

  /* Mengenwaehler: Knoepfe und Tippen fuehren beide auf denselben Weg. */
  doc.querySelectorAll(".mengew__b").forEach(function (b) {
    b.addEventListener("click", function () {
      if (!mengeFeld) return;
      mengeFeld.value = Math.min(10, Math.max(1, menge() + Number(b.dataset.schritt)));
      preisNachziehen();
    });
  });
  if (mengeFeld) mengeFeld.addEventListener("input", preisNachziehen);

  if (form) form.addEventListener("submit", function (e) { e.preventDefault(); ablegen(); });
  var kb = doc.getElementById("kaufbarBtn");
  // Kein direktes ablegen als Handler: der Klick reicht sonst das Event als
  // Buendel-ID durch und die Bestellung landet mit NaN in der Kasse.
  if (kb) kb.addEventListener("click", function () { ablegen(); });
  var kz = doc.getElementById("korbClose"), kw = doc.getElementById("korbWeiter"),
      ks = doc.getElementById("korbScrim");
  if (kz) kz.addEventListener("click", korbZu);
  if (kw) kw.addEventListener("click", korbZu);
  if (ks) ks.addEventListener("click", korbZu);
  addEventListener("keydown", function (e) { if (e.key === "Escape") korbZu(); });

  // Der Balkenpreis wird ausschliesslich von preisNachziehen gesetzt. Ein zweiter
  // Handler auf den Variantenkarten hat ihn frueher wieder auf den Grundpreis
  // zurueckgesetzt und die angehakten Zusatzartikel unterschlagen.
  preisNachziehen();
})();
